export default __webpack_public_path__ + "static/media/AchievementsImage.c23e985f.svg";